import { render, staticRenderFns } from "./EmailConfirmation.vue?vue&type=template&id=923250bc&scoped=true&"
import script from "./EmailConfirmation.vue?vue&type=script&lang=js&"
export * from "./EmailConfirmation.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/common/confirm/_confirm.scss?vue&type=style&index=0&id=923250bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923250bc",
  null
  
)

export default component.exports